import { Directive, ElementRef, HostListener, Inject, Input } from "@angular/core";

@Directive({
    selector: '[ifOverFlowXClass]'
})
export class HoaIfOverFlowXClassDirective {
    @Input() ifOverFlowXClass: string;

    constructor(@Inject(ElementRef) private $el: ElementRef) {}

    @HostListener('resize', ['$event']) onResize(event: KeyboardEvent) {
        this.$el.nativeElement.removeClass(this.ifOverFlowXClass);

        if (this.$el.nativeElement.scrollWidth > this.$el.nativeElement.clientWidth) {
            this.$el.nativeElement.addClass(this.ifOverFlowXClass);
        }
        else {
            this.$el.nativeElement.removeClass(this.ifOverFlowXClass);
        }
    }
}

